// extracted by mini-css-extract-plugin
export default {"clickableListLayout":"ListLayout_clickableListLayout__sndlZ"};